import APP from 'src/main.js'
import Event from './Event.js'

class TradeExpected extends Event {
    get trade_cancel(){
        let value = (this.constructor.employeeStore.event_relations.find(rel => (rel.parent_id === this.id)&&(rel.child_type==='TradeCancel'))||{}).child_id
        if(value){
            return this.constructor.employeeStore.events.find(ev => (ev.id === value)&&ev.id)
        } else {
            return null
        }
    }
    get trade(){
        return (this.trade_cancel||{}).trade
    }

    get linked(){
        return this.trade_cancel != null
    }

    // TradeExpected should always be matched with a Trade
    get should_be_linked() {
        return true
    }
}
export default TradeExpected
